"use client"
import React from 'react'
import Navbar from '../../components/client/common/Navbar';
import MainAllApplications from "../../components/client/Applications/allApplicaitons/MainAllApplications"

const AllApplications = () => {

  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="p-4 lg:p-8">
        <MainAllApplications/>
      </main>
    </div>
  )
}

export default AllApplications
